import {defineStore} from "pinia";
import {computed, type ComputedRef, type Ref, ref} from "vue";
import {getConfigByType} from "@/application/typeConfig/typeConfig.factory.ts";
import type AbstractType from "@/application/typeConfig/AbstractTypeConfig.ts";

export const useWorkflowStore = defineStore('workflow', () => {
  const companyId: Ref<string> = ref('')
  const courseId: Ref<string> = ref('')
  const courseNumGroup: Ref<string> = ref('')
  const type: Ref<string> = ref('')
  const config: ComputedRef<AbstractType|null> = computed(() => {
    if (!type.value) {
      return null
    }
    return getConfigByType(type.value)
  })
  return {
    companyId,
    courseId,
    courseNumGroup,
    config,
    type
  }
});
